// Utils
import { openTooltipThrottled } from './openTooltipThrottled';
/**
 * Import this function into any component that needs to open a tooltip.
 * This can be used directly in a `onMouseMove` event as the event dispatch
 * will be throttled.
 *
 * @param {HTMLDivElement} subscribedTooltipEventElement
 */
export var dispatchOpenTooltipEventOnThisElement = function (subscribedTooltipEventElement) {
    return function (x, y, contentData, getContent) {
        subscribedTooltipEventElement &&
            getContent &&
            openTooltipThrottled(subscribedTooltipEventElement, x, y, contentData, getContent);
    };
};
//# sourceMappingURL=dispatchOpenTooltipEventOnThisElement.js.map